import React from "react";
import { Login } from "../pages/login";
import { Logout } from "../pages/logout";
import { Private } from "../pages/private";
import { LoginSuccess } from "../pages/loginsuccess";
import {Overview} from "../pages/overview"
import {Requirements} from  "../pages/requriement"
import {TechSpec} from  "../pages/techspec"
import {InfrastructureContext} from "../pages/json"
import {Report} from "../pages/report"


const app_client = process.env.REACT_APP_CLIENT;

let nav = [
  { path: "/", name: "Login", element: <Login />, isMenu: false, isPrivate: false },
  //{ path: "/", name: "Login", element: <Overview />, isMenu: false, isPrivate: false },
  { path: "/overview", name: "Overview", element: <Overview />, isMenu: false, isPrivate: false },
  { path: "/login", name: "Login", element: <Login />, isMenu: false, isPrivate: false },
  { path: "/private", name: "Private", element: <Private />, isMenu: true, isPrivate: true },
  { path: "/login-success", name: "LoginSuccess", element: <LoginSuccess />, isMenu: false, isPrivate: false },
  { path: "/logout", name: "Logout", element: <Logout />, isMenu: true, isPrivate: false },
  { path: "/requirements", name: "Requirements", element: <Requirements />, isMenu: false, isPrivate: false },
  { path: "/tech-spec/:documentid/:documentname", name: "TechSpec", element: <TechSpec />, isMenu: false, isPrivate: false },
  { path: "/tech-spec", name: "TechSpec", element: <TechSpec />, isMenu: false, isPrivate: false },
  { path: "/infrastructure-context", name: "InfrastructureContext", element: <InfrastructureContext />, isMenu: false, isPrivate: false },
  { path: "/infrastructure-context/:documentid/:documentname", name: "InfrastructureContext", element: <InfrastructureContext />, isMenu: false, isPrivate: false },
  { path: "/infrastructure-context/:type", name: "InfrastructureContext", element: <InfrastructureContext />, isMenu: false, isPrivate: false },
  { path: "/report", name: "Report", element: <Report />, isMenu: false, isPrivate: false },
  
];
export { nav };
